<template>
  <div>
    <div class="toolbar">
      <div class="toolbar__row">
        <button
          v-b-modal.modal-add-size
          class="products__header-button"
          :disabled="!colorId || getDressesSize.length == 6"
          @click="getMaterialVByMandP"
        >
          {{ $t('AddBarcode') }}
        </button>
        <button
          v-if="articleIdsNumber.length > 0"
          v-b-modal.add-direct-instock
          class="products__header-button"
        >
          {{ $t('AddToStock') }}
        </button>
      </div>
    </div>
    <div>
      <table
        class="team_table"
      >
        <thead>
          <tr>
            <th />
            <th>
              {{ $t('Article') }}
            </th>
            <th
              v-if="$route.path.includes('products')"
            >
              {{ $t('Barcode') }}
            </th>
            <th>
              {{ $t('Code') }}
            </th>
            <th>
              {{ $t('Size') }}
            </th>
            <th>
              {{ $t('SellingPrice') }}
            </th>
            <th v-if="getLoggedInUser.role == 'CEO' || getLoggedInUser.role == 'Admin'">
              {{ $t('PurchasePrice') }}
            </th>
            <th
              v-if="$route.path.includes('products')"
            >
              {{ $t('Stock') }}
            </th>
            <th
              v-if="$route.path.includes('products')"
            >
              {{ $t('Edit') }}
            </th>
            <th
              v-if="$route.path.includes('create-order')"
            />
            <th
              v-if="$route.path.includes('products')"
            >
              {{ $t('QR-Code') }}
            </th>
          </tr>
        </thead>
        <LoadingSpinnerTable
          :is-loading="isRequestLoading('inventoryProductSizeFromColorId')"
          :response-data="getDressesSize"
        >
          <tr
            v-for="(item, index) in getDressesSize"
            :key="index"
            class="hover-row"
            style="cursor: pointer;"

            :style="classNameCh === item.inventoryProductId ? 'background-color: rgba(255, 39, 79, 0.1)' : ''"
            @click="matProps(item)"
          >
            <td>
              <input
                type="checkbox"
                :value="item.inventoryProductId"
                :checked="isItemChecked(item)"
                @change="event => toggleOrderItem(event, index)"
                @click.stop
              >
            </td>
            <td>
              {{ item.articleNumber }}
            </td>
            <td
              style="display:flex;gap:5px;align-items: center;"
            >
              <button
                v-if="item.code"
                v-b-tooltip.hover.bottom
                :title="$t('DownloadBarcode')"
                class="buttonSubmiti"
                @click.stop="downloadBARCODE(item.code);"
              >
                <b-icon-download />
              </button>
              <p v-else>
                {{ $t('NoBarcode') }}
              </p>
            </td>
            <td>
              {{ item.code }}
            </td>
            <td>
              {{ item.size }}
            </td>
            <td style="width: 17%;">
              {{ (item.price > 0 && item.price != null && item.price != '') ? numbersWithcomma(item.price) : item.price }} {{ item.currency }}
            </td>
            <td
              v-if="getLoggedInUser.role == 'CEO' || getLoggedInUser.role == 'Admin'"
              style="width: 17%;"
            >
              {{ (item.purchasePrice > 0 && item.purchasePrice != null && item.purchasePrice != '') ? numbersWithcomma(item.purchasePrice) : 0 }} {{ item.currency }}
            </td>
            <td
              v-if="$route.path.includes('products')"
              :style="
                $route.path.includes('products')
                  ? 'padding: 10px; text-align: left; cursor: pointer; color:#141414 !important ; font-weight: 400;'
                  : 'padding: 5px; color:#141414 !important ; font-weight: 400;'
              "
              @click="showModal(item)"
            >
              <button
                v-b-modal.add-direct-instock-one
                class="editButton"
                size="sm"
                style="border: none;width:120px;height: 30px;"
                @click="AddToCustom(item), edit(item)"
              >
                <span v-if="item.added">{{ $t('Added') }}</span>
                <span v-else> {{ $t('Add') }}</span>
              </button>
            </td>
            <td
              v-if="$route.path.includes('products')"
              v-b-modal.modal-edit-size
              :style="
                $route.path.includes('products')
                  ? 'padding: 10px; text-align: center; cursor: pointer; color:#141414 !important ; font-weight: 400;'
                  : 'padding: 5px; color:#141414 !important ; font-weight: 400;'
              "
              @click="edit(item)"
            >
              <b-icon-pencil />
            </td>
            <td
              v-if="$route.path.includes('create-order')"
              :style="
                $route.path.includes('products')
                  ? 'padding: 10px; text-align: left; cursor: pointer'
                  : 'padding: 5px'
              "
            >
              <button
                class="editButton"
                @click="AddToCustom(item)"
              >
                <span v-if="item.added">{{ $t('Added') }}</span>
                <span v-else> {{ $t('AddToS') }}</span>
              </button>
            </td>
            <td
              style="display:flex;gap:5px;align-items: center;"
            >
              <div
                v-b-tooltip.hover.left
                v-b-modal.qr-code
                :title="$t('QRCodeImage')"
                @click.stop="showQRCode(item.articleNumber)"
              >
                <qrcode-vue
                  ref="qrcode"
                  :value="item.articleNumber"
                  :size="30"
                  level="H"
                />
              </div>
              <button
                v-b-tooltip.hover.bottom
                :title="$t('DownloadQR')"
                class="buttonSubmiti"
                @click.stop="generateQRCode(item.articleNumber);"
              >
                <b-icon-download />
              </button>
            </td>
          </tr>
        </LoadingSpinnerTable>
      </table>
    </div>
    <AddSize
      :materials="materialId"
      :measure-item="measureId"
      :color-data="colorId"
      @variantMaterialData="variantMaterialData"
    />

    <AddDirectInStock
      :color-data="colorId"
      :materials="materialId"
      :measure-item="measureId"
      :e-size="eSize"
      :article-ids-number="articleIdsNumber"
      @resetArticles="resetArticlesUpdate"
      @AddDirectInStock="createOrderInStoreTemporary"
    />
    <AddDirectInStockOne
      :article-ids-number-one="articleIdsNumberOne"
      @resetArticlesOne="resetArticlesUpdateOne"
      @AddDirectInStock="createOrderInStoreTemporary"
    />
    <EditSize
      :color-data="colorId"
      :materials="materialId"
      :measure-item="measureId"
      :e-size="eSize"
      :code-existed="codeExisted"
      :pricess="prices"
      :materials-article-num="getMaterialsByArticleNum.productSingleMaterialVariantDtos"
      @updateSize="editSize"
    />
    <CreateOrderModal
      :added-article="rows"
      :materials="getMaterialsByArticleNum"
      @test="testt"
      @createOrder="createOrderInStore"
      @incrementCounter="increment"
      @decrementCounter="decrement"
    />
    <AddBodyMeasurement
      @addCalibration="calibrationAdd"
    />
    <QRCodeModal
      :selected-material-variant="selectedMaterialVariant"
    />
    <BarcodeModal
      :barcode-value="barcodeValue"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CreateOrderModal from '@/modals/CreateOrderModal.vue';
import AddSize from '@/components/products/modals/AddSize.vue';
import AddDirectInStock from '@/components/products/modals/AddDirectInStock.vue';
import AddDirectInStockOne from '@/components/products/modals/AddDirectInStockOne.vue';
import EditSize from '@/components/products/modals/EditSize.vue';
import QrcodeVue from 'qrcode.vue'
import QRCode from 'qrcode';
// eslint-disable-next-line import/no-extraneous-dependencies
import JsBarcode from 'jsbarcode';
import AddBodyMeasurement from './modals/AddBodyMeasurement.vue';
import { client } from '../../domainConfig';
import QRCodeModal from '../QRCodeModal.vue'
import BarcodeModal from '../BarcodeModal.vue'


export default {
  components: {
    AddSize,
    AddDirectInStock,
    CreateOrderModal,
    EditSize,
    AddBodyMeasurement,
    QrcodeVue,
    QRCodeModal,
    AddDirectInStockOne,
    BarcodeModal,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    materialId: {
      type: [String, Object],
    },
    createOrder: {
      type: Boolean,
    },
    // eslint-disable-next-line vue/require-default-prop
    colorId: {
      type: [String, Object],
    },
    measureId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      barcodeValue: null,
      articleIdsNumberOne: [],
      selectedMaterialVariant: null,
      articleNumberQrCode: null,
      articleNumberBarcode: null,
      initialId: '',
      materialPropId: '',
      modalVisible: false,
      client: client.clientName,
      status: true,
      size: '',
      prices: {
        price: 0,
        currency: '',
      },
      eSize: {
        size: '',
        code: '',
      },
      codeExisted: '',
      classNameCh: '',
      searchTerm: '',
      rows: [],
      materialObject: {},
      editMat: {},
      artNum: '',
      invProdId: '',
      counter: 0,
      inventoryProductsId: '',
      articleIdsNumber: [],
      oneProduct: null,
    };
  },
  computed: {
    ...mapGetters([
      'getDressesSize',
      'getCustomOrders',
      'getMaterialsByArticleNum',
      'getResetStatus',
      'getDressColors',
      'getMeasermentsById',
      'getLoggedInUser',
    ]),
  },
  watch: {
    getDressesSize(newVal) {
      if (newVal.length > 0) {
        this.handleDressesSizeChange(newVal);
      }
    },
    getResetStatus(value) {
      if (value == true) { this.rows = []; this.counter = 0; this.resetCustomOrders2() }
    },
    'materialId.name': {
      handler(value, newValue) {
        if (value != newValue) {
          this.colorId = null
        }
      },
    },
  },
  mounted() {
    // console.log('22', this.getMeasermentsById)
  },
  methods: {
    ...mapActions([
      'inventoryProductSizeFromColorId',
      'getInventoryProductsByColorId',
      'productsByArticleNumber',
      'addInventoryProductSize',
      'editInventoryProductSize',
      'addOrderInStore',
      'resetCustomOrders',
      'resetCustomOrders2',
      'getMaterialVariantsToMDCPagination',
      'resetDressColors',
      'resetSizes',
      'resetProductsByArticleNumber',
      'loadMeasermentsById',
      'addProductInStock',
      'addProductDirectInStock',
      'locations_by_type',
      'calibrationBodyMeasurement',
      'addCalibrationBodyMeasurement',
      'resetCodePersisted',
      'loadLocationsByStoreIdName',
      'isArticleOnCart',
      'addItemsArticleCart',
    ]),
    addOneProductInCart(value) {
      this.addItemsArticleCart({
        storeId: this.oneProduct.storeId,
        object: [value],
        successCallback: () => {
          this.selectAll = false
          this.orderItemIds = []
          this.itemIsAlreadyOnCart = '';
        },
      })
    },
    addOneProduct(value) {
      this.oneProduct = value
      this.isArticleOnCart({
        storeId: value.storeId,
        inventoryProductId: value.inventoryProductId,
      });
    },
    showTheBarcode(value) {
      this.barcodeValue = value
    },
    handleDressesSizeChange(dresses) {
      dresses.forEach((dress, index) => {
        this.generateBarcode(dress.code, index);
      });
    },
    resetArticlesUpdate() {
      this.articleIdsNumber = []
    },
    resetArticlesUpdateOne() {
      this.articleIdsNumberOne = []
    },
    toggleOrderItem(event, index) {
      const item = this.getDressesSize[index];
      const itemObject = {
        inventoryProductId: item.inventoryProductId,
        articleNumber: item.articleNumber,
        quantity: 1,
        minimalQuantity: 0,
      };

      if (event.target.checked) {
        this.articleIdsNumber.push(itemObject);
      } else {
        const itemIndex = this.articleIdsNumber.findIndex(
          (i) => { return i.inventoryProductId === item.inventoryProductId && i.articleNumber === item.articleNumber },
        );
        if (itemIndex !== -1) {
          this.articleIdsNumber.splice(itemIndex, 1);
        }
      }
    },
    isItemChecked(item) {
      return this.articleIdsNumber.some(
        (i) => { return i.inventoryProductId === item.inventoryProductId && i.articleNumber === item.articleNumber },
      );
    },
    showQRCode(value) {
      this.selectedMaterialVariant = value;
    },
    numbersWithcomma(value) {
      const options = {
        style: 'decimal', // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
      return value.toLocaleString('en-US', options);
    },
    calibrationAdd(value) {
      console.log('valueof', value)
      this.addCalibrationBodyMeasurement({
        inventoryId: this.inventoryProductsId,
        object: value,
        successCallback: () => {
          this.calibrationBodyMeasurement(this.inventoryProductsId)
        },
      })
    },
    calibration(value) {
      this.inventoryProductsId = value
      this.calibrationBodyMeasurement(value)
    },
    async testt(value) {
      // console.log('nammee', value);
      await this.loadMeasermentsById(value)
    },
    async generateAndDownloadBarCode() {
      const value = this.articleNumberBarCode;

      try {
        const canvas = document.createElement('canvas');

        // Check if the value can be an EAN-13 barcode (must be 12 or 13 digits)
        let format = 'CODE128'; // Default to CODE128

        // EAN-13 format check: Should be a 13-digit number
        if (/^\d{12,13}$/.test(value)) {
          format = 'EAN13';
        }

        // Generate the barcode with the chosen format
        JsBarcode(canvas, value, { format });

        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = `Barcode - ${value}.png`;
        link.click();
      } catch (error) {
        console.error('Error generating barcode:', error);
      }
    },
    downloadBARCODE(value) {
      this.articleNumberBarCode = value
      this.generateAndDownloadBarCode();
    },
    generateBarcode(articleNumber, index) {
      const canvas = this.$refs[`barcodeCanvas${index}`];
      JsBarcode(canvas, articleNumber, {
        format: 'CODE128',
        displayValue: true,
      });
    },
    async generateAndDownloadQRCode() {
      const value = this.articleNumberQrCode;

      try {
        const canvas = await QRCode.toCanvas(value, { width: 300 });

        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = `QRCode - ${this.articleNumberQrCode}`;
        link.click();
      } catch (error) {
        console.error('Error generating QR code:', error);
      }
    },
    generateQRCode(value) {
      this.articleNumberQrCode = value
      console.log('value', value)
      this.generateAndDownloadQRCode();
    },
    showModal(item) {
      this.locations_by_type('WarehouseForProductInStock')
      this.articleIdsNumberOne.push({
        articleNumber: item.articleNumber,
        inventoryProductId: item.inventoryProductId,
        quantity: 1,
        minimalQuantity: 0,
      })
    },
    edit(item) {
      this.prices.price = item.price
      this.prices.currency = item.currency
      this.eSize.size = item.size;
      this.eSize.code = item.code;
      this.codeExisted = item.code
      this.invProdId = item.inventoryProductId;
      this.getMaterialVByMandP()
      this.resetCodePersisted()
    },
    async editSize(obj) {
      await this.editInventoryProductSize({
        inventoryProductId: this.invProdId,
        object: obj,
        successCallback: () => {
          this.inventoryProductSizeFromColorId(this.colorId.mainDressCategoryColorId);
          this.productsByArticleNumber(this.artNum);
        },
      });
    },
    rr() {
      // this.loadOrderTypes()
      this.getMaterialVByMandP()
      if (this.getResetStatus == true) {
        this.rows = [];
      }
    },
    increment() {
      this.counter++;
    },
    decrement() {
      this.counter--;
    },
    async AddToCustom(item) {
      await this.productsByArticleNumber(item.articleNumber);
      const t = {
        twentyPrinciples: null,
        bodyMeasurements: {},
        itemi: item,
        pickUpDate: '',
        filledPickUpDate: true,
        materials: this.getMaterialsByArticleNum,
        probeDates: [],
        paidPrice: 0,
        price: 0,
      }
      console.log(t)
      this.rows.push(t);
      this.counter++;
      this.resetCustomOrders2();
      this.loadLocationsByStoreIdName({
        storeId: this.getLoggedInUser.storeId,
      })
    },
    async createOrderInStore(obj) {
      await this.addOrderInStore(obj);
      this.resetDressColors()
      this.resetSizes()
      this.resetProductsByArticleNumber()
    },
    async createOrderInStoreTemporary(value) {
      // await this.productsByArticleNumber(this.artNum);
      const object2 = []
      object2.push({
        bodyMeasurements: null,
        articleNumber: this.artNum,
        materialVariantDtos: this.getMaterialsByArticleNum,
      })
      const t = {
        articleNumber: this.artNum, productInStockMaterialVariantRequestDtos: object2, message: '', size: this.size, locationId: value.locationId,
      }
      this.rows.push(t);
      await this.addProductDirectInStock(value);
      this.resetProductsByArticleNumber()
      this.classNameCh = '';
    },
    async variantMaterialData(filterObj) {
      // eslint-disable-next-line no-unused-vars
      const addInvertoryObj = {
        mainDressCategoryId: this.materialId.id,
        mainDressCategoryColorId: this.colorId.mainDressCategoryColorId,
        ...filterObj,
      };
      await this.addInventoryProductSize({
        object: addInvertoryObj,
        successCallback: () => {
          this.inventoryProductSizeFromColorId(addInvertoryObj.mainDressCategoryColorId);
        },
      });
    },

    async matProps(mat) {
      // this.$emit('inside', mat)
      this.materialPropId = mat.materialId;
      this.classNameCh = mat.inventoryProductId;
      this.size = mat.size;
      this.artNum = mat.articleNumber;
      this.$emit('inventoryProductId', mat)
      await this.productsByArticleNumber(mat.articleNumber);
    },
    async getMaterialVByMandP() {
      // await this.getMaterialVariantsToMDCPagination({
      //   pageNumber: 1,
      //   pageSize: 15,
      //   measurement: 'Meter',
      // });
      // await this.getMaterialVariantsToMDCPagination({
      //   pageNumber: 1,
      //   pageSize: 15,
      //   measurement: 'Part',
      // });
      // await this.getMaterialVariantsToMDCPagination({
      //   pageNumber: 1,
      //   pageSize: 15,
      //   measurement: 'Package',
      // });
      // await this.getMaterialVariantsToMDCPagination({
      //   pageNumber: 1,
      //   pageSize: 15,
      //   measurement: 'Set',
      // });
      // await this.getMaterialVariantsToMDCPagination({
      //   pageNumber: 1,
      //   pageSize: 15,
      //   measurement: 'Pair',
      // });
      // await this.getMaterialVariantsToMDCPagination({
      //   pageNumber: 1,
      //   pageSize: 15,
      //   measurement: 'Verse',
      // });
      this.resetCodePersisted()
    },
  },
};
</script>

<style lang="scss">
.buttonSubmiti{
  background: #FF274F;
  border-color: white;
  color: $digit-white;
  width: 50px !important;
  border: transparent;
  height: 38px !important;
  border-radius: 6px;
}

.buttonSubmiti:hover{
  border: 2px solid #FF274F;
  background: white;
  color: #FF274F;
  transition: ease-in-out 0.3s;
  height: 38px !important;
  width: 50px !important;
}

.small:hover {
  border: 0.1px solid #FF274F !important;
  background: white;
  color: #FF274F;
  transition: ease-in-out 0.3s;
  width: 120px;
  height: 30px;
}
.modal-backdrop
{
    opacity:0.5 !important;
}
.modal-backdrop.show {
    opacity: 0.7;
}
.hover-row:hover {
    background-color: rgba(255, 39, 79, 0.1);
}
.products-listing__wrapper {
  .mats-listing {
    margin-top: 0;
  }
  .table__search-input {
    visibility: hidden;
  }
}
.button {
  margin-bottom: 15px !important;
  // width: 195.22px;
  // background: #FF274F !important;
  // color: #f4f1ed;
  // border-color: transparent;
}

.mat {
  display: flex;
  justify-content: space-between;
  align-content: center;
  &.active {
    background-color: #e8e8e8;
  }
  div {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }
  span {
    margin-left: 10px;
    svg {
      font-size: 15px;
    }
  }
}
.team_table {
  font-size: 12px;
  border-radius: 8px 8px 8px 8px !important;
}

.team_table td {
  padding: 10px 7px !important;
}

.team_table th {
  padding: 10px;
}

.team_table th:first-child {
  border-radius: 0px 0px 0px 0px;
}

.team_table th:last-child {
  border-radius: 0px 0px 0px 0px;
}


@media screen and (max-width: 1823px) {
  .products-listing__wrapper {
    width: 250px !important;
    margin-right: 5px;
    margin-left: 5px;
  }

  // }
  .products-listing__wrapper2 {
    width: 40% !important;
    margin-left: 5px;
    margin-right: 5px;

    button {
      width: 150px;
      font-size: 13px;
      height: 36px;
    }
  }
}
@media screen and (max-width: 1623px) {
  .products-listing__wrapper {
    width: 250px !important;
    margin-right: 5px;
    margin-left: 5px;
  }

  // }
  .products-listing__wrapper2 {
    width: 100% !important;
    margin-left: 5px;
    margin-right: 5px;

    button {
      width: 150px;
      font-size: 13px;
      height: 36px;
    }
  }
}
@media screen and (max-width: 1340px){
  .products-listing__wrapper {
    width: 180px !important;
    margin-right: 5px;
    margin-left: 5px;
  }
  .products-listing__wrapper2 {
    width: 100% !important;
    margin-left: 5px;
    margin-right: 5px;
  }
}
@media screen and (max-width: 1400px) {
  .products-listing__wrapper {
    width: 250px !important;
    margin-right: 5px;
    margin-left: 5px;
  }

  // }
  .products-listing__wrapper2 {
    width: 100% !important;
    margin-left: 5px;
    margin-right: 5px;

    button {
      width: 150px;
      font-size: 13px;
      height: 36px;
    }
  }
}

@media screen and (max-width: 1200px) {
  .products-listing__wrapper2 {
    width: 100% !important;
    margin-left: 10px
  }
  .buttonSubmiti {
    width:50px !important;
  }
}
@media screen and (max-width: 896px) {
  .products-listing__wrapper {
    width: auto !important;
    flex-basis: 30%;
  }
}
</style>
